import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import formStyles from '../../../styles/forms.module.scss';

function YourDataNotes(props) {
  const { notes, filenames } = props;

  let content;
  if (notes || filenames) {
    let notesContent;
    let filesContent;
    if (notes) {
      notesContent = (
        <div>
          <FormattedMessage id="offerWizard.yourData.notes" />
          <br />
          <span className={formStyles.breakWordAll}>{notes}</span>
        </div>
      );
    }

    if (filenames) {
      filesContent = (
        <div>
          <FormattedMessage id="offerWizard.yourData.notes.files" />
          <br />
          {filenames.map((filename) => (
            <div key={filename}>{filename}</div>
          ))}
        </div>
      );
    }

    content = (
      <>
        {notesContent}
        {filesContent}
      </>
    );
  }

  if (!content) {
    content = <FormattedMessage id="offerWizard.yourData.notes.noNotes" />;
  }
  return content;
}

YourDataNotes.defaultProps = {
  notes: '',
  filenames: null,
};

YourDataNotes.propTypes = {
  notes: PropTypes.string,
  filenames: PropTypes.arrayOf(PropTypes.string),
};

export default YourDataNotes;
